<div class="user-profile">
  <button
    class="user-profile-button"
    [class.user-profile-button--open]="open()"
    type="button"
    (click)="toggle()"
    [attr.aria-label]="'User menu'"
    [attr.aria-expanded]="open()"
  >
    <div class="user-avatar">
      <i class="pi pi-user"></i>
      <span class="user-status-dot" aria-hidden="true"></span>
    </div>
  </button>

  <div class="user-panel" [class.user-panel--open]="open()" role="menu">
    <div class="user-menu">
      <!-- User Header -->
      <div class="user-menu-header">
        <div class="user-avatar-large">
          <i class="pi pi-user"></i>
        </div>
        <div class="user-header-info">
          <p class="user-header-name">{{ userService$.user()?.fullName }}</p>
          <span class="user-header-email"
            >{{ userService$.user()?.login }}</span
          >
        </div>
      </div>
      <!--
      @if (getAvailableSubTypes().length) {
      <div class="user-subtype-switcher">
        <label class="subtype-dropdown-label">
          {{ 'olympiad_subtypes' | transloco }}
        </label>
        <div class="subtype-dropdown relative">
          <button
            type="button"
            class="subtype-dropdown-trigger"
            (click)="toggleSubtypeDropdown()"
          >
            <span> {{ currentOlympiadSubType | transloco }} </span>
            <i class="pi pi-chevron-down"></i>
          </button>
          @if (isSubtypeDropdownOpen()) {
          <div
            class="subtype-dropdown-panel absolute left-0 top-full mt-1 z-10"
          >
            @for (subType of getAvailableSubTypes(); track subType.value) {
            <button
              type="button"
              class="subtype-dropdown-item"
              [class.active]="
                      subType.value ===
                      (selectedSubType ?? userService$.user()?.currentOlympiadSubType)
                    "
              [disabled]="
                      isChangingSubType && pendingSubType === subType.value
                    "
              (click)="handleSubTypeSelect(subType.value, op)"
            >
              <span>{{ subType.label | transloco }}</span>
              @if ( subType.value === (selectedSubType ??
              userService$.user()?.currentOlympiadSubType) ) {
              <i class="pi pi-check"></i>
              } @if ( isChangingSubType && pendingSubType === subType.value ) {
              <i class="pi pi-spinner pi-spin"></i>
              }
            </button>
            }
          </div>
          }
        </div>
      </div>
      } -->

      <!-- User Menu Items -->
      <div class="user-menu-items">
        @for (item of userMenuItems; track item.label) {
        <button
          type="button"
          class="user-menu-item"
          (click)="handleMenuAction(item.action)"
        >
          <i [class]="item.icon"></i>
          <span>{{ item.label | transloco }}</span>
        </button>
        }
      </div>

      <!-- Logout Section -->
      <div class="user-menu-footer">
        <button type="button" class="logout-button" (click)="handleLogout()">
          <i class="pi pi-sign-out"></i>
          <span>{{ 'logout' | transloco }}</span>
        </button>
      </div>
    </div>
  </div>
</div>
